import { render, staticRenderFns } from "./Tune.vue?vue&type=template&id=52771fb0&scoped=true&"
import script from "./Tune.vue?vue&type=script&lang=js&"
export * from "./Tune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52771fb0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VMenu,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52771fb0')) {
      api.createRecord('52771fb0', component.options)
    } else {
      api.reload('52771fb0', component.options)
    }
    module.hot.accept("./Tune.vue?vue&type=template&id=52771fb0&scoped=true&", function () {
      api.rerender('52771fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tune.vue"
export default component.exports